export default "__VITE_ASSET__D$a3nYmH__"